module.exports = __webpack_public_path__ + "static/media/antworks.cb5cc6c0.png";